import { render, staticRenderFns } from "./list-reporting-table.vue?vue&type=template&id=58aa6061&scoped=true"
import script from "./list-reporting-table.vue?vue&type=script&lang=js"
export * from "./list-reporting-table.vue?vue&type=script&lang=js"
import style0 from "./list-reporting-table.vue?vue&type=style&index=0&id=58aa6061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aa6061",
  null
  
)

export default component.exports